import type { RootState } from '@/store/types';
import { createSelector } from '@reduxjs/toolkit';
import { LoadState } from '@/interfaces/general';
import { Chat, ChatList } from './IChats';

export const getPrivateChats = (state: RootState): ChatList => state.chats.privateChats
export const getMUChats = (state: RootState): ChatList => state.chats.muChats
export const getAllChats = createSelector(
  [getPrivateChats, getMUChats],
  (privateChats, muChats) => ({ ...privateChats, ...muChats })
)
export const isPrivateChatsLoaded = (state: RootState): boolean => state.chats.privateChatsLoaded === 'loaded'
export const isMuChatsLoaded = (state: RootState): boolean => state.chats.muChatsLoaded === 'loaded'
export const isThreadsLoaded = (state: RootState) => state.chats.threadsLoaded === 'loaded'
export const privateChatsLoaded = (state: RootState): LoadState => state.chats.privateChatsLoaded
export const muChatsLoaded = (state: RootState): LoadState => state.chats.muChatsLoaded
export const getActiveChatId = (state: RootState): string | null => state.chats.activeChatId
export const getActiveChat = (state: RootState): Chat | null => state.chats.activeChatId ?
  (state.chats.privateChats[state.chats.activeChatId] ||
    state.chats.muChats[state.chats.activeChatId] ||
    null) : null
export const getChat = (jid: string) =>
  (state: RootState) => state.chats.privateChats[jid] || state.chats.muChats[jid] || null
export const getPrivateChat = (jid: string) =>
  (state: RootState) => state.chats.privateChats[jid] || null


